import "./App.css";
import LandingPage from "./component/LandingPage/LandingPage";
import Navigation from "./component/Navigation/Navigation";

function App() {
  return (
    <>
      <Navigation />
      <LandingPage />
    </>
  );
}

export default App;
